export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-svg-legend/~/d3-scale/src/number.js
// module id = 71
// module chunks = 0